var exports = {
  "CB": "RoleManagement.module__roleIndicator___RFBtUG",
  "KG": "RoleManagement.module__roleBadge___RFBtUG",
  "Gy": "RoleManagement.module__roleRemoveButtonContainer___RFBtUG",
  "j1": "RoleManagement.module__roleRemoveButton___RFBtUG",
  "r4": "RoleManagement.module__roleRemoveIconContainer___RFBtUG",
  "S3": "RoleManagement.module__roleName___RFBtUG",
  "MR": "RoleManagement.module__roleListContainer___RFBtUG",
  "ek": "RoleManagement.module__assignRoleButton___RFBtUG",
  "JO": "RoleManagement.module__assignRoleButtonIcon___RFBtUG",
  "RK": "RoleManagement.module__iconSize___RFBtUG",
  "Xk": "RoleManagement.module__noRolesLink___RFBtUG",
  "X9": "RoleManagement.module__roleColorIndicator___RFBtUG",
};

module.exports = exports;
